import { render, staticRenderFns } from "./VerDiagnostico.vue?vue&type=template&id=91ed2dfe&"
import script from "./VerDiagnostico.vue?vue&type=script&lang=js&"
export * from "./VerDiagnostico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports